module.exports = __webpack_public_path__ + "media/images/human_ic-b184ac85122102a931c637c673956069.svg";